<template>
    <v-container grid-list-md fluid>
        <!-- ++ first title + icons row -->
        <v-row class="d-flex justify-space-between mb-1">
            <v-col cols="6" class="d-flex flex-column">
                <v-row no-gutters>
                    <v-col cols="1" class="d-flex align-center justify-center">
                        <v-btn-back @click="$router.push({ name: 'auditReport' })" />
                    </v-col>
                    <v-col cols="11" class="d-flex align-center">
                        <h2>Avoirs à établir (AAE) sur factures clients</h2>
                        <v-tooltip location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-btn-icon
                                    v-bind="props"
                                    size="large"
                                    class="ml-2"
                                    icon="$oss-help"
                                />
                            </template>
                            <p class="mb-0">
                                Sont affichés les factures et avoirs non lettrés, contenus dans les
                                c/411.
                            </p>
                            <p class="mb-0">
                                Les documents et paiements en attente de validation ou de lettrage
                                ne sont pas pris en compte. (à régulariser dans le contrôle balance
                                &#xe2;gée)
                            </p>
                            <p class="mb-0">
                                Sont affichés les AAE (c/4198), lettrés ou non lettrés, de
                                l'exercice sélectionné.
                            </p>
                            <p class="mb-0">
                                Effectuées avec les différents outils bobbee ou avec des ODs
                                manuelles.
                            </p>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="1" />
                    <v-col cols="10">
                        {{ `Statut : ${checkStatus}` }}
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6">
                <v-row no-gutters class="d-flex justify-end align-center">
                    <!-- ** upload -->
                    <v-tooltip location="bottom" text="Lier un document">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="dialogAuditCheckDocumentsManager = true"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-upload"
                                class="mx-1"
                            />
                        </template>
                    </v-tooltip>
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="openChat = !openChat"
                                v-bind="props"
                                class="btn"
                                size="x-small"
                                icon="$oss-chat"
                            >
                            </v-btn>
                        </template>
                        <span>Message</span>
                    </v-tooltip>

                    <!-- ** store -->
                    <v-btn
                        :disabled="
                            closedPeriod || validated || loading || dataLoading || !accountingPeriod
                        "
                        @click="createAdjustmentsData()"
                        size="small"
                        class="mx-1"
                    >
                        Enregistrer
                    </v-btn>

                    <!-- ** validate -->
                    <v-btn
                        :disabled="closedPeriod || loading || dataLoading || !accountingPeriod"
                        @click="validateFunction()"
                        size="small"
                        class="mx-1"
                    >
                        {{ validated ? "Invalider" : "Valider" }}
                    </v-btn>
                    <template v-if="isEnableReview">
                        <div
                            style="
                                border-right: 2px solid black;
                                width: 2px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />

                        <v-icon
                            :disabled="
                                reviewed === 1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-up"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = 1;
                                createAdjustmentsData('REVIEW');
                            "
                        />
                        <v-icon
                            :disabled="
                                reviewed === -1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-down"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = -1;
                                createAdjustmentsData('REVIEW');
                            "
                        />

                        <div
                            style="
                                border-right: 2px solid black;
                                width: 1px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />
                    </template>
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-prev
                                v-bind="props"
                                :disabled="!previousControl"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToPreviousControl();
                                "
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle précédent :
                            {{
                                previousControl && previousControl.title
                                    ? previousControl.title
                                    : ""
                            }}
                        </div>
                    </v-tooltip>
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-next
                                v-bind="props"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToNextControl();
                                "
                                :disabled="!nextControl"
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle suivant :
                            {{ nextControl && nextControl.title ? nextControl.title : "" }}
                        </div>
                    </v-tooltip>
                    <div
                        style="
                            border-right: 2px solid black;
                            width: 1px;
                            height: 25px;
                            margin: 0 4px;
                        "
                    />
                    <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                            <v-btn-icon
                                icon="$dots_vertical"
                                v-bind="props"
                                class="mx-1"
                                color="secondary"
                            />
                        </template>
                        <v-list nav>
                            <v-list-item @click="displayActivityDialog = true">
                                <v-list-item-title>Afficher l'activité</v-list-item-title>
                                <template v-slot:append>
                                    <v-icon>$oss-activity</v-icon>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-row>
            </v-col>
        </v-row>
        <div
            style="
                height: calc(100vh - 157px);
                overflow-y: auto;
                border-top-left-radius: 25px;
                border-top-right-radius: 25px;
            "
        >
            <!-- // ******** GLOBAL AMOUNTS ************************ -->

            <!-- ++ loading -->
            <template v-if="loading || dataLoading">
                <v-card
                    elevation="0"
                    style="background-color: #ffffff; border-radius: 25px; margin-top: 10px"
                >
                    <v-card-title class="pa-4 d-flex justify-center">
                        <v-progress-circular indeterminate class="mr-3" />
                    </v-card-title>
                </v-card>
            </template>

            <!-- ++ no accountingPeriod -->
            <template v-else-if="!accountingPeriod">
                <v-row no-gutters class="d-flex flex-column justify-center align-center mb-3">
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Aucune période sélectionnée</h3>
                </v-row>
            </template>

            <!-- ++ control -->
            <template v-else>
                <!-- ** closed period -->
                <v-row
                    no-gutters
                    v-if="closedPeriod"
                    class="d-flex flex-column justify-center align-center mb-3"
                >
                    <v-icon large class="mr-2 mb-1" color="primary"> $oss-warning </v-icon>
                    <h3>Période clôturée</h3>
                </v-row>

                <!-- ** no data -->
                <v-row no-gutters v-if="!globalAmounts || !globalAmounts.grossAmountSigned">
                    <v-col cols="12" class="d-flex justify-center">
                        <h4>Aucune facture ou avoir non lettré</h4>
                    </v-col>
                </v-row>

                <!-- ** Total créances calculées au -->
                <v-card
                    v-if="customers.length"
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                >
                    <v-row no-gutters class="justify-space-between">
                        <v-col cols="auto" class="d-flex justify-start">
                            <v-card-title>
                                <h5 class="pl-4">Total créances calculées au :</h5>
                            </v-card-title>
                        </v-col>

                        <v-col cols="2" class="d-flex justify-start">
                            <v-card-title>
                                <h5>
                                    <oss-date-picker
                                        v-model="selectedDate"
                                        @update:model-value="
                                            expand = false;
                                            expand4 = false;
                                        "
                                        :textFieldReadOnly="false"
                                        hide-details
                                    >
                                    </oss-date-picker>
                                    <!-- style="flex: 1;" -->
                                    <!-- "margin-right: auto; margin-left: auto;  -->
                                    <!-- style="display: inline-block; width: 100px;" -->
                                </h5>
                            </v-card-title>
                        </v-col>

                        <v-col class="ma-auto text-center">
                            <h5 v-if="globalAmounts.grossAmountSigned">
                                T.T.C. :
                                {{
                                    newCommonFormatCurrency(globalAmounts.grossAmountSigned, {
                                        currency: "",
                                        DC: true,
                                    })
                                }}
                            </h5>
                            <h5 v-else>T.T.C. : -</h5>
                        </v-col>

                        <v-col class="ma-auto text-center">
                            <h5 v-if="globalAmounts.netAmountSigned">
                                H.T. :
                                {{
                                    newCommonFormatCurrency(globalAmounts.netAmountSigned, {
                                        currency: "",
                                        DC: true,
                                    })
                                }}
                            </h5>
                            <h5 v-else>H.T. : -</h5>
                        </v-col>

                        <v-col class="ma-auto text-center">
                            <h5 v-if="globalAmounts.vatAmountSigned">
                                T.V.A. :
                                {{
                                    newCommonFormatCurrency(globalAmounts.vatAmountSigned, {
                                        currency: "",
                                        DC: true,
                                    })
                                }}
                            </h5>
                            <h5 v-else>T.V.A. : -</h5>
                        </v-col>

                        <v-col class="ma-auto text-center">
                            <h5 v-if="globalAmounts.cumulatedCreditNotes">
                                AAE émis :
                                {{
                                    newCommonFormatCurrency(globalAmounts.cumulatedCreditNotes, {
                                        currency: "",
                                        DC: true,
                                    })
                                }}
                            </h5>
                            <h5 v-else>AAE émis : -</h5>
                        </v-col>

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row no-gutters>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-icon v-if="validated"> $check_circle </v-icon>
                                </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            customersExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                        "
                                        @click="customersExpand = !customersExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <!-- // ************** TABLE OF PERIODS ***************** -->
                    <v-card-text v-show="customersExpand" transition="expand">
                        <v-card
                            v-if="customers.length"
                            elevation="0"
                            style="background-color: white; border-radius: 25px"
                            class="py-4"
                        >
                            <v-card-text class="pa-0">
                                <!-- // ** customers periods table -->
                                <v-data-table
                                    :headers="doubtfullAccountsHeaders"
                                    :items="customers"
                                    :sort-by="[{ key: 'customer.name', order: 'asc' }]"
                                    :loading="loading"
                                    class="table"
                                    style="border: 1px #ededed solid"
                                >
                                    <template #no-data>Aucune facture échue</template>

                                    <template v-slot:item="props">
                                        <tr>
                                            <!-- // **** Client ******* -->
                                            <td
                                                style="
                                                    font-weight: bold;
                                                    border-right: 1px solid #dddddd;
                                                "
                                            >
                                                {{ props.item.customer.name }}
                                            </td>

                                            <!-- // **** HT total ******* -->
                                            <td
                                                v-if="props.item.netAmountSigned"
                                                style="font-weight: bold"
                                                class="text-right"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.netAmountSigned,
                                                        { currency: "", DC: true },
                                                    )
                                                }}
                                            </td>
                                            <td v-else class="text-right">-</td>

                                            <!-- // **** TVA totale ******* -->
                                            <td
                                                v-if="props.item.vatAmountSigned"
                                                style="font-weight: bold"
                                                class="text-right"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.vatAmountSigned,
                                                        { currency: "", DC: true },
                                                    )
                                                }}
                                            </td>
                                            <td v-else class="text-right">-</td>

                                            <!-- // **** Créance TTC totale ******* -->
                                            <td
                                                v-if="
                                                    props.item.grossAmountSigned &&
                                                    props.item.documents
                                                "
                                                style="
                                                    font-weight: bold;
                                                    border-right: 1px solid #dddddd;
                                                "
                                                class="text-right"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.grossAmountSigned,
                                                        { currency: "", DC: true },
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="
                                                        openPeriodDocuments(
                                                            props.item,
                                                            ' : toutes périodes',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                />
                                            </td>
                                            <td
                                                v-else
                                                class="text-right"
                                                style="border-right: 1px solid #dddddd"
                                            >
                                                -
                                            </td>

                                            <!-- // **** Avoirs à établir déjà émis **** -->
                                            <td
                                                v-if="
                                                    props.item.cumulatedCreditNotes &&
                                                    props.item.existingCreditNotes
                                                "
                                                style="
                                                    font-weight: bold;
                                                    border-right: 1px solid #dddddd;
                                                "
                                                class="text-right"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.cumulatedCreditNotes,
                                                        { currency: "", DC: true },
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="
                                                        openCreditNotesList(
                                                            props.item.existingCreditNotes,
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                />
                                            </td>
                                            <td
                                                v-else
                                                class="text-right"
                                                style="border-right: 1px solid #dddddd"
                                            >
                                                -
                                            </td>

                                            <!-- // **** < 31 jrs ******* -->
                                            <td
                                                v-if="
                                                    props.item.period31 &&
                                                    props.item.period31.grossAmountSigned
                                                "
                                                class="text-right"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.period31.grossAmountSigned,
                                                        undefined,
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="
                                                        openPeriodDocuments(
                                                            props.item.period31,
                                                            ' - de 31 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                />
                                            </td>
                                            <td v-else class="text-right">-</td>

                                            <!-- // **** de 32 à 60 jrs ******* -->
                                            <td
                                                v-if="
                                                    props.item.period60 &&
                                                    props.item.period60.grossAmountSigned
                                                "
                                                class="text-right"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.period60.grossAmountSigned,
                                                        undefined,
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="
                                                        openPeriodDocuments(
                                                            props.item.period60,
                                                            ' - de 60 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                />
                                            </td>
                                            <td v-else class="text-right">-</td>

                                            <!-- // **** de 61 à 90 jrs ******* -->
                                            <td
                                                v-if="
                                                    props.item.period90 &&
                                                    props.item.period90.grossAmountSigned
                                                "
                                                class="text-right"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.period90.grossAmountSigned,
                                                        undefined,
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="
                                                        openPeriodDocuments(
                                                            props.item.period90,
                                                            ' - de 90 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                />
                                            </td>
                                            <td v-else class="text-right">-</td>

                                            <!-- // **** de 91 à 120 jrs ******* -->
                                            <td
                                                v-if="
                                                    props.item.period120 &&
                                                    props.item.period120.grossAmountSigned
                                                "
                                                class="text-right"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.period120.grossAmountSigned,
                                                        undefined,
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="
                                                        openPeriodDocuments(
                                                            props.item.period120,
                                                            ' - de 120 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                />
                                            </td>
                                            <td v-else class="text-right">-</td>

                                            <!-- // **** de 121 à 180 jrs ******* -->
                                            <td
                                                v-if="
                                                    props.item.period180 &&
                                                    props.item.period180.grossAmountSigned
                                                "
                                                class="text-right"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.period180.grossAmountSigned,
                                                        undefined,
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="
                                                        openPeriodDocuments(
                                                            props.item.period180,
                                                            ' - de 180 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                />
                                            </td>
                                            <td v-else class="text-right">-</td>

                                            <!-- // **** de 181 à 365 jrs ******* -->
                                            <td
                                                v-if="
                                                    props.item.period365 &&
                                                    props.item.period365.grossAmountSigned
                                                "
                                                class="text-right"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.period365.grossAmountSigned,
                                                        undefined,
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="
                                                        openPeriodDocuments(
                                                            props.item.period365,
                                                            ' - de 365 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                />
                                            </td>
                                            <td v-else class="text-right">-</td>

                                            <!-- // **** > 365 jrs ******* -->
                                            <td
                                                v-if="
                                                    props.item.periodMore &&
                                                    props.item.periodMore.grossAmountSigned
                                                "
                                                class="text-right"
                                                style="border-right: 1px solid #dddddd"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.periodMore.grossAmountSigned,
                                                        undefined,
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="
                                                        openPeriodDocuments(
                                                            props.item.periodMore,
                                                            ' + de 365 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                />
                                            </td>
                                            <td
                                                v-else
                                                class="text-right"
                                                style="border-right: 1px solid #dddddd"
                                            >
                                                -
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>

                                <!-- // ** btns OD + Enregistrer + Valider -->
                                <v-row no-gutters>
                                    <v-col style="padding-bottom: 0">
                                        <v-card-title
                                            style="
                                                padding-top: 20px;
                                                padding-bottom: 0;
                                                padding-left: 0;
                                            "
                                        >
                                            <v-spacer />

                                            <!-- // ** OD -->
                                            <v-btn
                                                v-if="closedPeriod || validated"
                                                rounded
                                                disabled
                                                size="small"
                                            >
                                                OD
                                            </v-btn>

                                            <v-btn
                                                v-else
                                                rounded
                                                class="btn btn_blue"
                                                @click="
                                                    createAdjustmentsData();
                                                    miscellanousOperationData = undefined;
                                                    miscellaneousOperationDialog = true;
                                                "
                                                size="small"
                                            >
                                                OD
                                            </v-btn>

                                            <!-- // ** Store data -->
                                            <v-btn
                                                v-if="closedPeriod || validated"
                                                disabled
                                                rounded
                                                class="btn btn_blue"
                                                size="small"
                                            >
                                                Enregistrer
                                            </v-btn>
                                            <v-btn
                                                v-else
                                                rounded
                                                class="btn btn_blue"
                                                @click.stop="createAdjustmentsData()"
                                                size="small"
                                            >
                                                Enregistrer
                                            </v-btn>

                                            <!-- // ** validate -->
                                            <v-btn
                                                v-if="closedPeriod"
                                                rounded
                                                class="btn btn_blue"
                                                disabled
                                                size="small"
                                            >
                                                Valider
                                            </v-btn>
                                            <v-btn
                                                v-else-if="!validated"
                                                rounded
                                                class="btn btn_blue"
                                                @click="
                                                    validated = !validated;
                                                    adjustmentsExpand = false;
                                                    createAdjustmentsData('VALIDATE');
                                                "
                                                size="small"
                                            >
                                                Valider
                                            </v-btn>
                                            <v-btn
                                                v-else
                                                rounded
                                                class="btn btn_blue"
                                                @click="
                                                    validated = !validated;
                                                    createAdjustmentsData('UPDATE');
                                                "
                                                size="small"
                                            >
                                                Invalider
                                            </v-btn>
                                        </v-card-title>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </v-card>

                <!-- // ************** DOCUMENTS LIST / PERIODS hidden in eye icon ******************* -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                    v-if="periodDocuments.length > 0"
                    v-show="expand"
                >
                    <v-expand-transition>
                        <v-card-text v-if="periodDocuments.length > 0" v-show="expand" class="pa-0">
                            <v-row class="px-5 pt-3">
                                <v-col>
                                    <h3>
                                        {{ periodsCustomer.name }} - Factures échues depuis
                                        {{ selectedPeriod }}
                                    </h3>
                                </v-col>
                            </v-row>

                            <v-card-text class="py-4">
                                <v-data-table
                                    :headers="periodDocumentsHeaders"
                                    :items="periodDocuments"
                                    :sort-by="[
                                        { key: 'date' },
                                        { key: 'netAmountSigned' },
                                        { key: 'grossAmountSigned' },
                                        { key: 'dueDate' },
                                        { key: 'name' },
                                    ]"
                                    :loading="loading"
                                    class="table"
                                    style="border: 1px #ededed solid"
                                >
                                    <template #no-data
                                        >Aucune facture échue sur la période</template
                                    >

                                    <template v-slot:item="props">
                                        <tr>
                                            <!-- // *** Date *** -->
                                            <td v-if="props.item.date" class="text-center">
                                                {{ formatDate(props.item.date) }}
                                            </td>
                                            <td v-else class="text-center">-</td>

                                            <!-- // *** text *** -->
                                            <td v-if="props.item.text" class="text-left">
                                                {{ props.item.text }}
                                            </td>
                                            <td v-else class="text-left">-</td>

                                            <!-- // *** invoiceNumber *** -->
                                            <td v-if="props.item.invoiceNumber" class="text-left">
                                                {{ props.item.invoiceNumber }}
                                            </td>
                                            <td v-else class="text-left">-</td>

                                            <!-- // *** netAmountSigned *** -->
                                            <td v-if="props.item.doc7and6" class="text-right">
                                                {{
                                                    newCommonFormatCurrency(props.item.doc7and6, {
                                                        currency: "",
                                                        DC: true,
                                                    })
                                                }}
                                            </td>
                                            <td v-else class="text-right">-</td>

                                            <!-- // *** vatAmountSigned *** -->
                                            <td v-if="props.item.doc445" class="text-right">
                                                {{
                                                    newCommonFormatCurrency(props.item.doc445, {
                                                        currency: "",
                                                        DC: true,
                                                    })
                                                }}
                                            </td>
                                            <td v-else class="text-right">-</td>

                                            <!-- // *** grossAmountSigned *** -->
                                            <td v-if="props.item.doc411" class="text-right">
                                                {{
                                                    newCommonFormatCurrency(props.item.doc411, {
                                                        currency: "",
                                                        DC: true,
                                                    })
                                                }}
                                            </td>
                                            <td v-else class="text-right">-</td>

                                            <!-- // *** dueDate *** -->
                                            <td v-if="props.item.dueDate" class="text-center">
                                                {{ formatDate(props.item.dueDate) }}
                                            </td>
                                            <td v-else class="text-center">-</td>

                                            <!-- // *** openDocument *** -->
                                            <td class="text-center pl-2 py-0">
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="openDocument(props.item)"
                                                />
                                            </td>

                                            <!-- // *** spellcheck or date *** -->
                                            <td
                                                v-if="
                                                    props.item.cctiAuditCheckResult &&
                                                    props.item.cctiAuditCheckResult.results &&
                                                    props.item.cctiAuditCheckResult.results[0] &&
                                                    props.item.cctiAuditCheckResult.results[0].date
                                                "
                                                class="text-center pl-2 py-0"
                                                cols="1"
                                            >
                                                {{
                                                    formatDate(
                                                        props.item.cctiAuditCheckResult.results[0]
                                                            .date,
                                                    )
                                                }}
                                            </td>

                                            <td v-else class="text-center pl-2 py-0" cols="1">
                                                <v-btn-icon
                                                    icon="$spellcheck"
                                                    v-if="accountingPeriod.closed"
                                                    disabled
                                                    color="primary"
                                                />

                                                <v-btn-icon
                                                    icon="$spellcheck"
                                                    @click="
                                                        openCreditNoteDialog(
                                                            props.item,
                                                            periodsCustomer,
                                                        )
                                                    "
                                                />
                                            </td>

                                            <!-- // ** icon more_vert(ical) with upsert + deleteACR -->
                                            <td
                                                class="text-center"
                                                style="border-left: 1px #ededed solid"
                                            >
                                                <!-- // // start -->
                                                <v-menu offset-y>
                                                    <template v-slot:activator="{ props }">
                                                        <v-btn-icon
                                                            icon="$dots_vertical"
                                                            v-bind="props"
                                                            class="mx-1"
                                                            color="secondary"
                                                        />
                                                    </template>

                                                    <v-list>
                                                        <v-list-item
                                                            v-if="accountingPeriod.closed"
                                                            disabled
                                                        >
                                                            <v-list-item-title>
                                                                Créer ou modifier l'avoir à établir
                                                            </v-list-item-title>

                                                            <template v-slot:append>
                                                                <v-icon>$spellcheck</v-icon>
                                                            </template>
                                                        </v-list-item>

                                                        <v-list-item
                                                            v-else
                                                            @click="
                                                                openCreditNoteDialog(
                                                                    props.item,
                                                                    periodsCustomer,
                                                                )
                                                            "
                                                        >
                                                            <v-list-item-title>
                                                                Créer ou modifier l'avoir à établir
                                                            </v-list-item-title>

                                                            <template v-slot:append>
                                                                <v-icon
                                                                    :color="actionColor(props.item)"
                                                                >
                                                                    $spellcheck
                                                                </v-icon>
                                                            </template>
                                                        </v-list-item>

                                                        <v-list-item
                                                            v-if="
                                                                props.item.cctiAuditCheckResult &&
                                                                props.item.cctiAuditCheckResult.id
                                                            "
                                                            @click="
                                                                deleteAuditCheckResult(
                                                                    props.item.cctiAuditCheckResult
                                                                        .id,
                                                                )
                                                            "
                                                        >
                                                            <v-list-item-title
                                                                >Supprimer l'avoir à
                                                                établir</v-list-item-title
                                                            >
                                                            <template v-slot:append>
                                                                <v-icon size="small">
                                                                    $oss-trash
                                                                </v-icon>
                                                            </template>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card-text>
                    </v-expand-transition>
                </v-card>

                <!-- // ************** PREVIOUS CREDIT NOTES LIST hidden in eye icon ************* -->
                <v-card
                    elevation="0"
                    class="px-4 my-4"
                    style="border-radius: 25px"
                    v-if="existingCreditNotes.length > 0"
                    v-show="expand4"
                >
                    <div style="background-color: white; border-radius: 25px">
                        <v-expand-transition>
                            <v-card-text
                                v-if="existingCreditNotes.length > 0"
                                v-show="expand4"
                                class="pa-0"
                            >
                                <v-row class="px-5 pt-3">
                                    <v-col>
                                        <h3>{{ creditNotesCustomer.name }} - Avoirs à établir</h3>
                                    </v-col>
                                </v-row>

                                <v-card-text class="py-4">
                                    <v-data-table
                                        :headers="creditNotesListHeaders"
                                        :items="existingCreditNotes"
                                        :sort-by="[
                                            { key: 'date' },
                                            { key: 'name' },
                                            { key: 'netAmountSigned' },
                                            { key: 'grossAmountSigned' },
                                        ]"
                                        :loading="loading"
                                        class="table"
                                        style="border: 1px #ededed solid"
                                    >
                                        <template #no-data
                                            >Aucun passage en perte irrécouvrable
                                            précédente</template
                                        >

                                        <template v-slot:item="props">
                                            <tr>
                                                <!-- // *** DATE ***  -->
                                                <td v-if="props.item.date" class="text-center">
                                                    {{ formatDate(props.item.date) }}
                                                </td>
                                                <td v-else>-</td>

                                                <!-- // *** Libellé *** -->
                                                <td v-if="props.item.name">
                                                    {{ props.item.name }}
                                                </td>
                                                <td v-else />

                                                <!-- // *** HT *** -->
                                                <template
                                                    v-for="(al, index) in props.item
                                                        .accountingLines"
                                                    :key="index"
                                                >
                                                    <td
                                                        v-if="
                                                            al.accountableAccount &&
                                                            al.accountableAccount.name &&
                                                            al.accountableAccount.name.startsWith(
                                                                '7',
                                                            ) &&
                                                            al.amountSigned
                                                        "
                                                        :key="index"
                                                        class="text-right"
                                                    >
                                                        {{
                                                            newCommonFormatCurrency(
                                                                al.amountSigned,
                                                                { currency: "", DC: true },
                                                            )
                                                        }}
                                                    </td>

                                                    <!-- // *** TVA *** -->
                                                    <td
                                                        v-if="
                                                            al.accountableAccount &&
                                                            al.accountableAccount.name &&
                                                            al.accountableAccount.name.startsWith(
                                                                '445',
                                                            ) &&
                                                            al.amountSigned &&
                                                            !al.accountableAccount.name.startsWith(
                                                                '7',
                                                            ) &&
                                                            !al.accountableAccount.name.startsWith(
                                                                '41',
                                                            )
                                                        "
                                                        :key="index"
                                                        class="text-right"
                                                    >
                                                        {{
                                                            newCommonFormatCurrency(
                                                                al.amountSigned,
                                                                { currency: "", DC: true },
                                                            )
                                                        }}
                                                    </td>
                                                    <td
                                                        v-else-if="
                                                            props.item.accountingLines.length ===
                                                                2 &&
                                                            !al.accountableAccount.name.startsWith(
                                                                '41',
                                                            )
                                                        "
                                                        class="text-right"
                                                    >
                                                        -
                                                    </td>

                                                    <!-- // *** TTC *** -->
                                                    <td
                                                        v-if="
                                                            al.accountableAccount &&
                                                            al.accountableAccount.name &&
                                                            al.accountableAccount.name.startsWith(
                                                                '41',
                                                            ) &&
                                                            al.amountSigned
                                                        "
                                                        :key="index"
                                                        class="text-right"
                                                    >
                                                        {{
                                                            newCommonFormatCurrency(
                                                                al.amountSigned,
                                                                { currency: "", DC: true },
                                                            )
                                                        }}
                                                    </td>
                                                </template>

                                                <!-- // *** openDocument *** -->
                                                <td class="text-center pl-2 py-0">
                                                    <v-btn-icon
                                                        icon="$remove_red_eye"
                                                        @click="openDocument(props.item)"
                                                    />
                                                </td>

                                                <!-- // ** icon more_vert(ical) with upsert + deleteACR -->
                                                <td
                                                    class="text-center"
                                                    style="border-left: 1px #ededed solid"
                                                >
                                                    <!-- // // start -->
                                                    <v-menu offset-y>
                                                        <template v-slot:activator="{ props }">
                                                            <v-btn-icon
                                                                icon="$dots_vertical"
                                                                v-bind="props"
                                                                class="mx-1"
                                                                color="secondary"
                                                            />
                                                        </template>

                                                        <v-list>
                                                            <v-list-item
                                                                v-if="
                                                                    props.item.isResultOf &&
                                                                    props.item.isResultOf.id &&
                                                                    (!accountingPeriod ||
                                                                        !accountingPeriod.closed)
                                                                "
                                                                @click="
                                                                    deleteAuditCheckResult(
                                                                        props.item.isResultOf.id,
                                                                    )
                                                                "
                                                            >
                                                                <v-list-item-title
                                                                    >Supprimer l'avoir à
                                                                    établir</v-list-item-title
                                                                >
                                                                <template v-slot:append>
                                                                    <v-icon size="small">
                                                                        $oss-trash
                                                                    </v-icon>
                                                                </template>
                                                            </v-list-item>

                                                            <v-list-item v-else disabled>
                                                                <v-list-item-title>
                                                                    Supprimer l'avoir à établir
                                                                </v-list-item-title>

                                                                <template v-slot:append>
                                                                    <v-icon size="small">
                                                                        $oss-trash
                                                                    </v-icon>
                                                                </template>
                                                            </v-list-item>
                                                        </v-list>
                                                    </v-menu>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                            </v-card-text>
                        </v-expand-transition>
                    </div>
                </v-card>

                <!-- // ** GeneralLedger 411 -->
                <v-card
                    v-show="show411NL || show411NLNextPeriod"
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row no-gutters>
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Grand livre c/411</h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row no-gutters>
                                <v-col cols="6" class="align-center pa-0">
                                    <!-- <v-icon v-if="validated" icon="$check_circle" /> -->
                                </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            generalLedgerExpand411
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="generalLedgerExpand411 = !generalLedgerExpand411"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-show="generalLedgerExpand411" transition="expand">
                        <!-- // ** 411 detailled -->
                        <v-card
                            v-for="(period, x) in periods"
                            :key="x"
                            style="background-color: white; border-radius: 25px; padding: 10px"
                            class="my-5"
                        >
                            <v-card-title v-if="period.period === 'N'">
                                Solde {{ period.period }} :
                                {{
                                    newCommonFormatCurrency(totalBalance411NL, {
                                        currency: "",
                                        DC: true,
                                    })
                                }}
                            </v-card-title>

                            <v-card-title v-else>
                                Solde {{ period.period }} :
                                {{
                                    newCommonFormatCurrency(totalBalance411NLNextPeriod, {
                                        currency: "",
                                        DC: true,
                                    })
                                }}
                            </v-card-title>

                            <v-card-text>
                                <v-row no-gutters>
                                    <v-col :key="refreshGeneralLedger411">
                                        <GeneralLedger
                                            :companyId="companyId"
                                            :accountingPeriodId="period.id"
                                            :thirdPartyType="'411'"
                                            :inNm1="false"
                                            @query-done="period.onQueryDone"
                                        />
                                        <!-- :store="true" > default value = false - take options from the store (to avoid in audits) -->
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </v-card>

                <!-- // ** GeneralLedger 4198, ... -->
                <v-card
                    v-show="show4198NL || totalBalance4198NLNextPeriod"
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row no-gutters>
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 v-if="items.accountableAccountsRoot.length" class="pl-4">
                                    Grand livre c/{{
                                        getTextFromStringArray(items.accountableAccountsRoot)
                                    }}
                                </h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row no-gutters>
                                <v-col cols="6" class="align-center pa-0">
                                    <!-- <v-icon v-if="validated" icon="$check_circle" /> -->
                                </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            generalLedgerExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="generalLedgerExpand = !generalLedgerExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-show="generalLedgerExpand" transition="expand">
                        <!-- // ** 4198 -->
                        <v-card
                            v-for="(period, y) in periods"
                            :key="y"
                            style="background-color: white; border-radius: 25px; padding: 10px"
                            class="my-5"
                        >
                            <v-card-title v-if="period.period === 'N'">
                                Solde {{ period.period }} :
                                {{
                                    newCommonFormatCurrency(totalBalance4198NL, {
                                        currency: "",
                                        DC: true,
                                    })
                                }}
                            </v-card-title>

                            <v-card-title v-else>
                                Solde {{ period.period }} :
                                {{
                                    newCommonFormatCurrency(totalBalance4198NLNextPeriod, {
                                        currency: "",
                                        DC: true,
                                    })
                                }}
                            </v-card-title>

                            <v-card-text>
                                <!-- // // switchs generalLedger -->
                                <!-- <v-row no-gutters>
                                    <v-col>
                                        <v-switch inset v-model="withoutLettering" :label="'Cacher les éléments léttrés'" class="ml-2"></v-switch>
                                    </v-col>
                                    <v-col>
                                        <v-switch inset v-model="withoutBank" :label="'Cacher la trésorerie'" class="ml-2"></v-switch>
                                    </v-col>
                                    <v-col>
                                        <v-switch inset v-model="withoutDocument" :label="'Cacher les justificatifs'" class="ml-2"></v-switch>
                                    </v-col>
                                </v-row> -->

                                <v-row no-gutters>
                                    <v-col :key="refreshGeneralLedger411">
                                        <GeneralLedger
                                            :companyId="companyId"
                                            :accountingPeriodId="period.id"
                                            :accountableAccountFilter="
                                                items.accountableAccountsRoot
                                            "
                                            :inNm1="false"
                                            @query-done="period.onQueryDone2"
                                            ref="generalLedger"
                                            :enableAuditedAccountableAccounts="true"
                                        />
                                        <!-- :store="true" > default value = false - take options from the store (to avoid in audits) -->
                                    </v-col>
                                </v-row>

                                <!-- // ** OD -->
                                <v-row no-gutters>
                                    <v-col style="padding-bottom: 0">
                                        <v-card-title
                                            style="
                                                padding-top: 20px;
                                                padding-bottom: 0;
                                                padding-left: 0;
                                            "
                                        >
                                            <v-spacer />

                                            <v-btn
                                                v-if="closedPeriod || validated"
                                                rounded
                                                disabled
                                                size="small"
                                            >
                                                OD
                                            </v-btn>
                                            <v-btn
                                                v-else
                                                rounded
                                                class="btn btn_blue"
                                                @click="
                                                    createAdjustmentsData();
                                                    miscellanousOperationData = undefined;
                                                    miscellaneousOperationDialog = true;
                                                "
                                                size="small"
                                            >
                                                OD
                                            </v-btn>
                                        </v-card-title>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <br />
                        </v-card>
                    </v-card-text>
                </v-card>

                <!-- // ** connectedDocuments -->
                <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrDocuments
                        :connectedDocuments="connectedDocuments"
                        :companyId="companyId"
                        :acKey="acKey"
                        :auditCheckResult="auditCheckResult || {}"
                        :accountingPeriodId="accountingPeriodId || undefined"
                        @unlinkedDocument="unlinkDocument($event)"
                        @showLinkedDocument="showLinkedDocument($event)"
                    />
                </template>

                <!-- // ** results -->
                <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrResults :results="results" :companyId="companyId" />
                </template>

                <!-- // ** long comments -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row no-gutters>
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Commentaires détaillés</h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row no-gutters>
                                <v-col cols="6" class="align-center pa-0">
                                    <!-- <v-icon v-if="validated" icon="$check_circle" /> -->
                                </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            commentExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                        "
                                        @click="commentExpand = !commentExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-if="commentExpand" transition="expand">
                        <v-row class="pt-6">
                            <v-col style="padding-top: 0">
                                <v-card-text style="padding: 0">
                                    <v-textarea
                                        v-model="comment"
                                        :disabled="closedPeriod || validated"
                                        auto-grow
                                        style="border: 1px #ededed solid"
                                        outlined
                                    />
                                    <!-- :key="i" -->
                                </v-card-text>
                            </v-col>
                        </v-row>

                        <v-row no-gutters>
                            <v-col style="padding-bottom: 0">
                                <v-card-title
                                    style="padding-top: 20px; padding-bottom: 0; padding-left: 0"
                                >
                                    <v-spacer />

                                    <!-- // ** OD -->
                                    <v-btn
                                        v-if="closedPeriod || validated"
                                        rounded
                                        disabled
                                        size="small"
                                    >
                                        OD
                                    </v-btn>

                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue"
                                        @click="
                                            createAdjustmentsData();
                                            miscellanousOperationData = undefined;
                                            miscellaneousOperationDialog = true;
                                        "
                                        size="small"
                                    >
                                        OD
                                    </v-btn>

                                    <!-- // ** Store data -->
                                    <v-btn
                                        v-if="closedPeriod || validated"
                                        disabled
                                        rounded
                                        class="btn btn_blue"
                                        size="small"
                                    >
                                        Enregistrer
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue"
                                        @click.stop="createAdjustmentsData()"
                                        size="small"
                                    >
                                        Enregistrer
                                    </v-btn>

                                    <!-- // ** validate -->
                                    <v-btn
                                        v-if="closedPeriod"
                                        rounded
                                        class="btn btn_blue"
                                        disabled
                                        size="small"
                                    >
                                        Valider
                                    </v-btn>
                                    <v-btn
                                        v-else-if="!validated"
                                        rounded
                                        class="btn btn_blue"
                                        @click="
                                            validated = !validated;
                                            adjustmentsExpand = false;
                                            createAdjustmentsData('VALIDATE');
                                        "
                                        size="small"
                                    >
                                        Valider
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue"
                                        @click="
                                            validated = !validated;
                                            createAdjustmentsData('UPDATE');
                                        "
                                        size="small"
                                    >
                                        Invalider
                                    </v-btn>
                                </v-card-title>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- // ** shortComment -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row no-gutters>
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Commentaires synthétiques</h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row no-gutters>
                                <v-col cols="6" class="align-center pa-0">
                                    <!-- <v-icon v-if="validated" icon="$check_circle" /> -->
                                </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            shortCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="shortCommentExpand = !shortCommentExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-if="shortCommentExpand" transition="expand">
                        <v-row class="pt-6">
                            <v-col style="padding-top: 0">
                                <v-card-text style="padding: 0">
                                    <v-textarea
                                        v-model="shortComment"
                                        :disabled="closedPeriod || validated"
                                        auto-grow
                                        style="border: 1px #ededed solid"
                                        outlined
                                    />
                                    <!-- :key="i" -->
                                </v-card-text>
                            </v-col>
                        </v-row>

                        <v-row no-gutters>
                            <v-col style="padding-bottom: 0">
                                <v-card-title
                                    style="padding-top: 20px; padding-bottom: 0; padding-left: 0"
                                >
                                    <v-spacer />

                                    <!-- // ** OD -->
                                    <v-btn
                                        v-if="closedPeriod || validated"
                                        rounded
                                        disabled
                                        size="small"
                                    >
                                        OD
                                    </v-btn>

                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue"
                                        @click="
                                            createAdjustmentsData();
                                            miscellanousOperationData = undefined;
                                            miscellaneousOperationDialog = true;
                                        "
                                        size="small"
                                    >
                                        OD
                                    </v-btn>

                                    <!-- // ** Store data -->
                                    <v-btn
                                        v-if="closedPeriod || validated"
                                        disabled
                                        rounded
                                        class="btn btn_blue"
                                        size="small"
                                    >
                                        Enregistrer
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue"
                                        @click.stop="createAdjustmentsData()"
                                        size="small"
                                    >
                                        Enregistrer
                                    </v-btn>

                                    <!-- // ** validate -->
                                    <v-btn
                                        v-if="closedPeriod"
                                        rounded
                                        class="btn btn_blue"
                                        disabled
                                        size="small"
                                    >
                                        Valider
                                    </v-btn>
                                    <v-btn
                                        v-else-if="!validated"
                                        rounded
                                        class="btn btn_blue"
                                        @click="
                                            validated = !validated;
                                            adjustmentsExpand = false;
                                            createAdjustmentsData('VALIDATE');
                                        "
                                        size="small"
                                    >
                                        Valider
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue"
                                        @click="
                                            validated = !validated;
                                            createAdjustmentsData('UPDATE');
                                        "
                                        size="small"
                                    >
                                        Invalider
                                    </v-btn>
                                </v-card-title>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- // ********* DIALOG - CREDIT NOTE EMIT ******* -->
                <v-dialog
                    v-if="creditNoteDialog"
                    v-model="creditNoteDialog"
                    width="90%"
                    class="justify-space-around"
                >
                    <v-card>
                        <v-toolbar color="primary" class="elevation-0">
                            <v-toolbar-title v-if="selectedCustomer && selectedCustomer.name">
                                {{ selectedCustomer.name }} - Passer un avoir à établir (AAE)
                            </v-toolbar-title>
                            <v-spacer />
                            <v-btn-icon icon="$close" @click="quitCreditNoteDialog" />
                        </v-toolbar>

                        <v-window v-model="step">
                            <!-- // +++++ step 1 - choice of date -->
                            <v-window-item :value="1">
                                <v-card>
                                    <v-card-text>
                                        <!-- // ++ INVOICE ** -->
                                        <v-row no-gutters>
                                            <v-col cols="3">
                                                <h3 v-if="invoice && invoice.date">Créance</h3>
                                            </v-col>

                                            <v-col cols="3">
                                                <h3 v-if="invoice && invoice.date">
                                                    {{ formatDate(invoice.date) }}
                                                </h3>
                                            </v-col>

                                            <v-col cols="3">
                                                <h3 v-if="invoice.doc7and6">
                                                    {{
                                                        newCommonFormatCurrency(invoice.doc7and6, {
                                                            currency: "",
                                                            DC: true,
                                                        })
                                                    }}
                                                    HT
                                                </h3>
                                            </v-col>

                                            <v-col cols="3">
                                                <h3 v-if="invoice.doc445">
                                                    {{
                                                        newCommonFormatCurrency(invoice.doc445, {
                                                            currency: "",
                                                            DC: true,
                                                        })
                                                    }}
                                                    TVA
                                                </h3>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>

                                <v-card>
                                    <v-card-text>
                                        <!-- // ++ CREDIT NOTE -->
                                        <h2 class="pb-4" />

                                        <v-row no-gutters>
                                            <v-col cols="3">
                                                <h3 style="margin-top:">Avoir à établir</h3>
                                            </v-col>

                                            <v-col cols="3">
                                                {{ formatDate(creditNote.date) }}
                                            </v-col>

                                            <v-col cols="3">
                                                <oss-text-field
                                                    v-if="invoice.doc7and6"
                                                    v-model="selected7and6AmountSigned.amount"
                                                    :rules="[
                                                        (v) =>
                                                            v <= -invoice.doc7and6 ||
                                                            'Valeur maximale ' +
                                                                [-invoice.doc7and6],
                                                        (v) => v >= 0 || 'Valeur minimale ' + [0],
                                                    ]"
                                                    label="HT"
                                                    outlined
                                                    dense
                                                    @update:model-value="calculateAdjustments()"
                                                />
                                            </v-col>

                                            <v-col cols="3">
                                                <oss-text-field
                                                    v-if="invoice.doc445"
                                                    v-model="selected445AmountSigned.amount"
                                                    :rules="[
                                                        (v) =>
                                                            v <= -invoice.doc445 ||
                                                            'Valeur maximale ' + [-invoice.doc445],
                                                        (v) => v >= 0 || 'Valeur minimale ' + [0],
                                                    ]"
                                                    label="TVA"
                                                    outlined
                                                    dense
                                                    @update:model-value="calculateAdjustments()"
                                                />
                                            </v-col>
                                        </v-row>

                                        <v-data-table
                                            v-if="
                                                creditNote &&
                                                creditNote.accountingLines &&
                                                creditNote.accountingLines.create
                                            "
                                            :headers="creditNoteHeaders"
                                            :items="creditNote.accountingLines.create"
                                            :loading="loading"
                                            class="table"
                                            style="border: 1px #ededed solid"
                                        >
                                            <template #no-data
                                                >Aucune note de credit à établir</template
                                            >

                                            <template v-slot:item="props">
                                                <tr>
                                                    <!-- // **** date ******* -->
                                                    <td style="border-right: 1px solid #dddddd">
                                                        {{ formatDate(props.item.date) }}
                                                    </td>

                                                    <!-- // **** accountableAccount ******* -->
                                                    <td
                                                        v-if="
                                                            props.item.accountableAccount &&
                                                            props.item.accountableAccount.connect &&
                                                            props.item.accountableAccount.connect
                                                                .uniqueName.name
                                                        "
                                                        style="border-right: 1px solid #dddddd"
                                                    >
                                                        {{
                                                            props.item.accountableAccount.connect
                                                                .uniqueName.name
                                                        }}
                                                    </td>

                                                    <td
                                                        v-else-if="
                                                            props.item.accountableAccount &&
                                                            props.item.accountableAccount.name
                                                        "
                                                    >
                                                        {{
                                                            props.item.accountableAccount.connect
                                                                .uniqueName.name
                                                        }}
                                                    </td>

                                                    <td
                                                        v-else
                                                        style="border-right: 1px solid #dddddd"
                                                    />

                                                    <!-- // **** wording ******* -->
                                                    <td style="border-right: 1px solid #dddddd">
                                                        {{ props.item.wording }}
                                                    </td>

                                                    <!-- // **** D ******* -->
                                                    <td
                                                        v-if="
                                                            props.item.amountSigned &&
                                                            props.item.amountSigned > 0
                                                        "
                                                        style="border-right: 1px solid #dddddd"
                                                    >
                                                        {{
                                                            newCommonFormatCurrency(
                                                                Math.abs(props.item.amountSigned),
                                                                undefined,
                                                            )
                                                        }}
                                                    </td>

                                                    <td
                                                        v-else
                                                        style="border-right: 1px solid #dddddd"
                                                    />

                                                    <!-- // **** C ******* -->
                                                    <td
                                                        v-if="
                                                            props.item.amountSigned &&
                                                            props.item.amountSigned < 0
                                                        "
                                                        style="border-right: 1px solid #dddddd"
                                                    >
                                                        {{
                                                            newCommonFormatCurrency(
                                                                Math.abs(props.item.amountSigned),
                                                                undefined,
                                                            )
                                                        }}
                                                    </td>

                                                    <td
                                                        v-else
                                                        style="border-right: 1px solid #dddddd"
                                                    />
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-card-text>
                                </v-card>

                                <v-divider />

                                <v-card-actions style="padding-right: 24px; padding-left: 24px">
                                    <v-btn
                                        rounded
                                        class="ma-2"
                                        @click="previous(1)"
                                        :color="'secondary'"
                                    >
                                        Précédent
                                    </v-btn>
                                    <v-spacer />

                                    <v-btn
                                        rounded
                                        class="ma-2"
                                        :color="'primary'"
                                        @click="validateCreditNote()"
                                        :disabled="disabledValidateBtn"
                                    >
                                        Valider
                                    </v-btn>
                                </v-card-actions>
                            </v-window-item>
                        </v-window>
                    </v-card>
                </v-dialog>
                <oss-dialog
                    v-model="displayActivityDialog"
                    v-if="displayActivityDialog"
                    title="Activité"
                    valid-title="Fermer"
                    @valid="displayActivityDialog = false"
                    @close="displayActivityDialog = false"
                    min-width="60vw"
                >
                    <UsersActivitiesHistory
                        :auditCheckKey="acKey"
                        :accountingPeriodId="accountingPeriodId"
                    >
                    </UsersActivitiesHistory>
                </oss-dialog>

                <!-- <AccountingItemEdition
                    v-model="miscellaneousOperationDialog"
                    :companyId="companyId"
                    :prefilledRows="miscellanousOperationData"

                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult"
                    :accountingPeriodId="accountingPeriodId"
                    @upsert="refresh()"
                    v-if="miscellaneousOperationDialog"
                ></AccountingItemEdition> -->

                <oss-dialog
                    v-model="miscellaneousOperationDialog"
                    :actions="actionsMiscellaneousOperation"
                    min-width="90vw"
                >
                    <AccountingItemEdition2
                        v-if="miscellaneousOperationDialog"
                        :companyId="companyId"
                        :prefilledRows="miscellanousOperationData"
                        :acKey="acKey"
                        :auditCheckResult="auditCheckResult"
                        :accountingPeriodId="accountingPeriodId"
                        @upsert="refresh()"
                        :actions="actionsMiscellaneousOperation"
                    />
                </oss-dialog>
                <Chat
                    :auditCheckAccountingPeriodKey="chatId"
                    v-if="openChat"
                    v-bind:chatTitle="'Chat'"
                />
                <AuditCheckDocumentsManager
                    v-model="dialogAuditCheckDocumentsManager"
                    v-if="dialogAuditCheckDocumentsManager"
                    :disabled="loading || dataLoading || !accountingPeriod"
                    :companyId="companyId"
                    :documentToDisplay="documentToDisplay"
                    :connectedDocuments="connectedDocuments || []"
                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult || {}"
                    :accountingPeriodId="accountingPeriodId || undefined"
                    :alreadyLinkedDoc="alreadyLinkedDoc"
                    @upsertedAuditCheckResult="upsertedACR"
                    @resetDialogData="
                        alreadyLinkedDoc = false;
                        documentToDisplay = {};
                    "
                />
            </template>
        </div>
        <!-- :accountingItemType="'MISCELLANEOUS_OPERATION'" -->
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Apollo } from "@/decorators";
import { cloneDeep, isEmpty } from "lodash";

import { mathFix } from "../../services/mathServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { getTextFromStringArray } from "../../../../backend/src/common/audit/auditFunctions";
import { closedPeriod, formatConnectedDocuments } from "../../services/audit/AuditServices";

import AccountingItemEdition2 from "../accounting/accountingItem/Edition.vue";
import GeneralLedger from "../GeneralLedger2.vue";
import AuditCheckDocumentsManager from "./AuditCheckDocumentsManager.vue";
import AuditConnectedAcrDocuments from "./AuditConnectedAcrDocuments.vue";
import AuditConnectedAcrResults from "./AuditConnectedAcrResults.vue";
import Chat from "../chat/Chat.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";

// //////////////////// APOLLO ////////////////////////
import AUDIT_ITEMS from "../../graphql/audit/AuditItems.gql";
import UPSERT_AUDIT_CHECK_RESULT from "../../graphql/audit/UpsertAuditCheckResultClosure.gql";
import UPDATE_CLOSURE_CREDIT_NOTE from "../../graphql/document/UpdateDocumentClosureCreditNote.gql";
import UPSERT_AUDIT_CHECK_RESULT__CONNECT_EXISTING_DOCUMENT from "../../graphql/audit/UpsertAuditCheckResultConnectExistingDocument.gql";
import DELETE_AUDIT_CHECK_RESULT_AND_RESULTS from "../../graphql/audit/DeleteAuditCheckResultId.gql";

import { getEmptyDocument } from "../../services/documentServices";

import { CheckBase } from "./CheckBase";
import { getDBFormattedEndDate } from "@/services/dateServices";
import { getConnectAccountableAccount } from "../../services/accountableAccountServices";
import { DialogAction } from "@/services/dialogAction";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        GeneralLedger,
        AuditCheckDocumentsManager,
        AuditConnectedAcrDocuments,
        AuditConnectedAcrResults,
        Chat,
        UsersActivitiesHistory,
        AccountingItemEdition2,
    },
})
export class CheckCreditNotesToIssue extends CheckBase {
    @Prop({ type: Boolean }) readonly active!: Boolean;
    @Prop({ default: "" }) documentId: string;

    loading: boolean = false;
    dataLoading: boolean = true;

    dialogAuditCheckDocumentsManager: boolean = false;

    accountingPeriodEnd: string = "";
    endPeriodDate = "";
    customersExpand: boolean = false;

    company: any = {};

    firstOpenPeriodStart: string = "";
    lastOpenPeriodEnd: string = "";
    nextAccountingPeriod: any = {};
    periods: Array<any> = [];

    // auditCheckKey: string = "xhtWyyZWjARdHDxNMtWAmUwMV"
    auditCheckResult: any = null;
    auditCheckResultId = "";

    noResults: boolean = false;
    // currentDocumentData: Array<any> = []
    currentDocACRid: string = "";
    // currentDocACR: any = null
    // previousDocumentsIds: Array<any> = [];
    resultDocumentIdsToDelete: Array<any> = [];
    validated: boolean = false;
    comment: string = "";
    shortComment: string = "";

    styleDialogDivider: string = "margin-top: 20px;";

    alreadyLinkedDoc: boolean = false;

    // searchCustomer = ""

    // // +++++++++++ RESET +++++++++++++++++
    // defaultFilter() {
    //     this.searchCustomer = "";
    // }

    // @Watch("searchCustomer")
    // onFilterChanged() {
    //     this.chatsPagination.page = 1;
    // }

    creditNoteDialog: boolean = false;

    show: boolean = false;

    expand: boolean = false;
    expand2: boolean = true;
    expand4: boolean = false;
    adjustmentsExpand: boolean = false;
    commentExpand: boolean = false;
    shortCommentExpand: boolean = false;

    generalLedgerExpand: boolean = false;
    generalLedgerExpand411: boolean = false;

    showGeneralLedger: boolean = false;
    showGeneralLedger411: boolean = false;

    show411NL: boolean = false;
    show411NLNextPeriod: boolean = false;
    show4198NL: boolean = false;
    show4198NLNextPeriod: boolean = false;

    totalBalance411NL: Number = 0;
    totalBalance411NLNextPeriod: Number = 0;

    totalBalance4198NL: Number = 0;
    totalBalance4198NLNextPeriod: Number = 0;

    accountableAccountFilter: Array<any> = ["411"];

    refreshGeneralLedger: number = 1;
    refreshGeneralLedger411: number = 1;

    miscellaneousOperationDialog: boolean = false;
    miscellanousOperationData: Array<any> = [];

    selectedCustomer: any = {};

    selectedDate: string = "";
    minDate: string = "";
    maxDate: string = "";

    // periodYear: string = ""
    // invoicesNotToPay: Array<any> = []

    // ** creditNote basis :
    invoice: any = {};
    selected7and6AmountSigned: any = {
        amount: 0,
        positif: true,
    };

    selected445AmountSigned: any = {
        amount: 0,
        positif: true,
    };

    dateCreditNote: any = moment().format("YYYY-MM-DD");
    creditNote: any = {};
    // creditNotes: Array<any> = []
    existingCreditNotes: Array<any> = [];

    globalCreditNoteNetAmount: number = 0.0;
    globalCreditNoteVatAmount: number = 0.0;
    globalCreditNoteVatRate: number = 0.0;
    calculatedVatRate: number = 0.0;
    globalCreditNoteGrossAmount: number = 0.0;

    invoiceNumber: string = "";

    accountingTransactions: Array<any> = [];
    withoutLettering: boolean = false;
    withoutBank: boolean = false;
    withoutDocument: boolean = false;

    connectedDocuments: Array<any> = [];
    results: Array<any> = [];
    documentToDisplay: any = {};

    actionsMiscellaneousOperation = {
        action: new DialogAction(),
    };

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    getTextFromStringArray(array: Array<string>) {
        return getTextFromStringArray(array);
    }

    get checkStatus() {
        if (this.validated && this.reviewed === 1) {
            return "Validé par le responsable";
        }
        if (this.validated && this.reviewed === -1) {
            return "Refusé par le responsable";
        }
        if (this.validated && this.reviewed === 0) {
            return "En attente de validation par le responsable";
        }
        if (!this.validated && !this.auditCheckResult) {
            return "A faire";
        }
        if (!this.validated && this.auditCheckResult) {
            return "En cours";
        }
        return "statut manquant";
    }

    // get companyId() {
    //     return this.$store.state.selected_company.id
    // }

    // get company() {
    //     return this.$store.state.selected_company
    // }

    // get accountingPeriodId() {
    //     return this.$store.state.accountingPeriod.selectedAccountingPeriod ?  this.$store.state.accountingPeriod.selectedAccountingPeriod.id : '';
    // }

    // get accountingPeriod() {
    //     return this.$store.state.accountingPeriod.selectedAccountingPeriod ? this.$store.state.accountingPeriod.selectedAccountingPeriod : '';
    // }

    // ++++ The DatePicker needs a format 'YYYY-MM-DD' +++++
    formatDatePicker(date: string) {
        return moment(date).format("YYYY-MM-DD");
    }

    formatDate(date: string) {
        return moment(date).format("DD/MM/YYYY");
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    // ********** HEADERS - DUES SALES-INVOICES ***********
    doubtfullAccountsHeaders: Array<any> = [
        {
            title: "Client",
            value: "customer",
            align: "left",
            sortable: true,
        },
        {
            title: "HT total",
            value: "netAmountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "TVA totale",
            value: "vatAmountSigned",
            align: "right",
            sortable: false,
        },
        {
            title: "Créance TTC totale",
            value: "grossAmountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "AAE déjà émis",
            value: "cumulatedCreditNotes",
            align: "right",
            sortable: true,
        },
        {
            title: "< 31 jrs",
            value: "period31",
            align: "right",
            sortable: true,
        },
        {
            title: "de 32 à 60 jrs",
            value: "period60",
            align: "right",
            sortable: true,
        },
        {
            title: "de 61 à 90 jrs",
            value: "period90",
            align: "right",
            sortable: true,
        },
        {
            title: "de 91 à 120 jrs",
            value: "period120",
            align: "right",
            sortable: true,
        },
        {
            title: "de 121 à 180 jrs",
            value: "period180",
            align: "right",
            sortable: true,
        },
        {
            title: "de 181 à 365 jrs",
            value: "period365",
            align: "right",
            sortable: true,
        },
        {
            title: "> 365 jrs",
            value: "periodMore",
            align: "right",
            sortable: true,
            // },
            // {
            //     title: "",
            //     value: "",
            //     align: "right",
            //     sortable: false
        },
    ];

    // ********** HEADERS - LIST OF SALES-INVOICES / DUE PERIOD ***********
    periodDocumentsHeaders: Array<any> = [
        {
            title: "Date",
            value: "date",
            align: "center",
            sortable: true,
        },
        {
            title: "Libellé",
            value: "name",
            align: "left",
            sortable: true,
        },
        {
            title: "N. de facture",
            value: "invoiceNumber",
            align: "left",
            sortable: true,
        },
        {
            title: "HT",
            value: "netAmountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "TVA totale",
            value: "vatAmountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "TTC",
            value: "grossAmountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "Echéance",
            value: "dueDate",
            align: "center",
            sortable: true,
        },
        {
            title: "Voir le document",
            value: "",
            align: "center",
            sortable: true,
        },
        {
            title: "AAE",
            value: "",
            align: "center",
            sortable: true,
        },
        {
            title: "",
            value: "",
            align: "center",
            sortable: false,
        },
    ];

    // ********** HEADERS - LIST OF PREVIOUS CREDIT NOTES ***********
    creditNotesListHeaders: Array<any> = [
        {
            title: "Date avoir",
            value: "date",
            align: "center",
            sortable: true,
        },
        {
            title: "Libellé",
            value: "name",
            align: "left",
            sortable: true,
        },
        {
            title: "HT",
            value: "netAmount",
            align: "right",
            sortable: true,
        },
        {
            title: "TVA",
            value: "vatAmount",
            align: "right",
            sortable: true,
        },
        {
            title: "TTC",
            value: "grossAmount",
            align: "right",
            sortable: true,
        },
        {
            title: "Voir",
            value: "",
            align: "center",
            sortable: true,
        },
        {
            title: "",
            value: "",
            align: "center",
            sortable: false,
        },
    ];

    // ********** HEADERS - LIST OF PREVIOUS CREDIT NOTES ***********
    detailedCreditNotesHeaders: Array<any> = [
        {
            text: "Date facture",
            value: "date",
            align: "center",
            sortable: true,
        },
        {
            text: "Numéro facture",
            value: "",
            align: "center",
            sortable: true,
        },
        {
            text: "Client",
            value: "thirdPartyCompany",
            align: "left",
            sortable: true,
        },
        {
            text: "HT",
            value: "netAmount",
            align: "right",
            sortable: true,
        },
        {
            text: "TVA",
            value: "vatAmount",
            align: "right",
            sortable: true,
        },
        {
            text: "TTC",
            value: "grossAmount",
            align: "right",
            sortable: true,
        },
    ];

    creditNoteHeaders: Array<any> = [
        {
            title: "Date",
            value: "date",
            align: "right",
            sortable: true,
        },
        {
            title: "Compte",
            value: "name",
            align: "right",
            sortable: true,
        },
        {
            title: "Libéllé",
            value: "wording",
            align: "right",
            sortable: true,
        },
        {
            title: "Débit",
            value: "amountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "Credit",
            value: "amountSigned",
            align: "right",
            sortable: true,
        },
    ];

    beforeMount() {
        this._mounted();
        this.searchAccountingPeriod();
    }

    afterAccountingPeriodFound() {
        if (this.accountingPeriodId && this.accountingPeriod) {
            this.periods.push({
                period: "N",
                id: this.accountingPeriodId,
                onQueryDone: (data) => {
                    this.onQueryDone411NL(data);
                },
                onQueryDone2: (data) => {
                    this.onQueryDone4198NL(data);
                },
            });

            // this.accountingPeriod = this.accountingPeriods.find(ap => ap.id === this.accountingPeriodId)
            if (this.accountingPeriod?.end) {
                this.selectedDate = this.formatDatePicker(this.accountingPeriod.end);

                const nextAccountingPeriodStart = moment(this.accountingPeriod.end)
                    .add(1, "days")
                    .startOf("day")
                    .format("YYYY-MM-DD");
                if (this.accountingPeriods && this.accountingPeriods.length) {
                    this.nextAccountingPeriod = this.accountingPeriods.find((ap) =>
                        ap.start.startsWith(nextAccountingPeriodStart),
                    );

                    if (this.nextAccountingPeriod && this.nextAccountingPeriod.id) {
                        this.periods.push({
                            period: "N+1",
                            id: this.nextAccountingPeriod.id,
                            onQueryDone: (data) => {
                                this.onQueryDone411NLNextPeriod(data);
                            },
                            onQueryDone2: (data) => {
                                this.onQueryDone4198NLNextPeriod(data);
                            },
                        });
                    }
                }
            }
        } else {
            this.selectedDate = this.formatDatePicker(moment().format());
        }

        const closedPeriodEnds = [];
        let sortClosedPeriodEnd = [];
        let lastClosedPeriodEnd = "";

        for (const ap of this.accountingPeriods) {
            if (ap.closed === true) {
                closedPeriodEnds.push(ap.end);
            }
        }
        if (closedPeriodEnds.length === 1) {
            lastClosedPeriodEnd = closedPeriodEnds[0];
        } else if (closedPeriodEnds.length > 1) {
            sortClosedPeriodEnd = closedPeriodEnds.sort((a, b) => {
                if (a.end < b.end) return -1;
                if (a.end > b.end) return 1;
                return 0;
            });
            lastClosedPeriodEnd = sortClosedPeriodEnd[sortClosedPeriodEnd.length - 1];
            this.firstOpenPeriodStart = moment(lastClosedPeriodEnd).clone().add(1, "days").format();
        }
        // ** this.minDate - dialog datepickeer
        if (lastClosedPeriodEnd) {
            this.firstOpenPeriodStart = moment(lastClosedPeriodEnd).clone().add(1, "days").format();
        } else {
            this.firstOpenPeriodStart = moment(this.accountingPeriods[0].start).format();
        }

        // ** this.maxDate - dialog datepickeer
        if (
            lastClosedPeriodEnd &&
            lastClosedPeriodEnd < this.accountingPeriods[this.accountingPeriods.length - 1].end
        ) {
            this.lastOpenPeriodEnd = this.formatDatePicker(
                this.accountingPeriods[this.accountingPeriods.length - 1].end,
            );
        } else {
            this.lastOpenPeriodEnd = this.formatDatePicker(
                this.accountingPeriods[this.accountingPeriods.length - 1].end,
            );
        }
    }

    // ***********************************************************
    // ********** APOLLO - errMessages - customers - globalAmounts ***
    @Apollo({
        query: AUDIT_ITEMS,
        variables() {
            return {
                companyId: this.companyId,
                auditCheck: "CheckCreditNotesToIssue",
                auditCheckKey: this.acKey,
                accountingPeriodId: this.accountingPeriodId || undefined,
                // ERIC DATE TO CHECK BY MONICA
                date_lte: this.selectedDate
                    ? getDBFormattedEndDate(this.selectedDate)
                    : this.accountingPeriod?.end
                      ? getDBFormattedEndDate(this.accountingPeriod.end)
                      : getDBFormattedEndDate(moment()),
            };
        },
        skip() {
            return !this.companyId || !this.accountingPeriodId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.dataLoading = true;
                if (data && data.auditItems && data.auditItems.items && data.auditItems.items[0]) {
                    this.items = cloneDeep(data.auditItems.items[0]);

                    this.company = this.items.company;

                    if (!this.selectedDate && this.items.output?.resume?.resumeDate) {
                        this.selectedDate = this.formatDatePicker(
                            this.items.output.resume.resumeDate,
                        );
                    }

                    if (this.items.output?.customers && !isEmpty(this.items.output?.customers)) {
                        this.customers = Object.values(this.items.output.customers);

                        this.results = this.items.output.customersAcrsResults || [];

                        if (this.items.output?.resume) {
                            this.globalAmounts = this.items.output.resume;
                        } else {
                            this.globalAmounts = [];
                        }
                    } else {
                        this.customers = [];
                        this.globalAmounts = [];
                    }

                    if (this.items.item?.auditCheckResult?.id) {
                        this.auditCheckResult = this.items.item.auditCheckResult;
                        this.auditCheckResultId = this.auditCheckResult.id;

                        if (this.auditCheckResult.documents) {
                            this.connectedDocuments = this.auditCheckResult.documents;
                        }

                        if (this.auditCheckResult.reviewed) {
                            this.reviewed = this.auditCheckResult.reviewed;
                        }

                        // ** auditCheckResult.results are in this.customers[customer].results

                        this.aaData = this.auditCheckResult.data[0] || undefined;
                        if (this.aaData) {
                            this.comment = this.aaData.comment || "";
                            this.shortComment = this.aaData.shortComment || "";
                            this.validated = this.aaData.validated || false;
                        }
                    } else {
                        this.auditCheckResultId = "";
                        this.comment = "";
                        this.shortComment = "";
                        this.validated = false;
                    }

                    // ** GeneralLedger - accountableAccounts
                    if (this.items.item?.accountableAccounts?.length) {
                        this.accountableAccounts = this.items.item.accountableAccounts;
                    }
                } else {
                    this.items = [];
                }
                this.dataLoading = false;
            }
        },
    })
    items: any = {};

    customers: Array<any> = [];

    globalAmounts: Array<any> = [];

    accountableAccounts: any = [];

    aaData: Array<any> = [];

    reviewed: number = 0;

    async fetchTotals(detailledBalanceInfos) {
        if (this.accountableAccounts.length) {
            if (
                detailledBalanceInfos &&
                Object.keys(detailledBalanceInfos).length &&
                detailledBalanceInfos.aaName
            ) {
                const foundedAA = this.accountableAccounts.find(
                    (aa) => aa.name === detailledBalanceInfos.aaName,
                );
                if (foundedAA) {
                    const indexFoundedAA = this.accountableAccounts.indexOf(foundedAA);

                    this.accountableAccounts[indexFoundedAA].queryLength =
                        detailledBalanceInfos.queryLength;

                    this.accountableAccounts[indexFoundedAA].aaName = detailledBalanceInfos.aaName;

                    this.accountableAccounts[indexFoundedAA].totalBalance =
                        detailledBalanceInfos.totalBalance;
                }

                // eslint-disable-next-line no-prototype-builtins
                const allFetchsDone = this.accountableAccounts.every((accAccount) =>
                    accAccount.hasOwnProperty("queryLength"),
                );

                if (allFetchsDone) {
                    // *** if any lines received
                    const noQueryLengths = !this.accountableAccounts.some(
                        (accAccount) => accAccount.queryLength > 0,
                    );
                    if (noQueryLengths) {
                        this.noResults = true;
                    } else if (!this.auditCheckResultId) {
                        this.createAdjustmentsData();
                    }
                }
            }
        } else {
            debugger; // git-ignore
        }
    }

    async createAdjustmentsData(action = undefined) {
        const data = [
            {
                comment: this.comment || "",
                shortComment: this.shortComment || "",
                validated: this.validated || false,
            },
        ];

        let auditCheckResultVariables: any = {};

        if (this.acKey && this.companyId && this.accountingPeriodId) {
            auditCheckResultVariables = {
                id:
                    this.auditCheckResultId && this.auditCheckResultId.length
                        ? this.auditCheckResultId
                        : "",
                key: this.acKey + "_" + this.companyId + "_" + this.accountingPeriodId,
                companyId: this.companyId,
                // thirdPartyCompany: {connect: {id: this.selectedCustomer.id}},
                status: this.validated ? "VALIDATED" : "EDITION",
                // thirdPartyCompanyCreate: al.object && al.object.thirdPartyCompany && al.object.thirdPartyCompany.id ? { connect: { id:al.object.thirdPartyCompany.id } } : undefined,
                // thirdPartyCompanyUpdate: al.object && al.object.thirdPartyCompany && al.object.thirdPartyCompany.id ? { connect: { id:al.object.thirdPartyCompany.id } } : undefined,
                accountingPeriodCreate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                accountingPeriodUpdate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                data: JSON.parse(JSON.stringify(data)) || [],
                auditCheckKey: this.acKey,
                type: "IN_AUDIT_REPORT",
                // deleteDocuments: [], // ** previous results, if to delete
                // documents: [],  // ** results = générés par le contrôle
                connectDocuments: formatConnectedDocuments(this.connectedDocuments), // ** docs liés
                reviewed: this.reviewed,
            };
        }
        if (auditCheckResultVariables) {
            await this.$apollo.mutate({
                mutation: UPSERT_AUDIT_CHECK_RESULT,
                variables: auditCheckResultVariables,
            });
        }

        // await this.createUserActivity(action) // deprecated

        // ++++++++++++++ RESET +++++++++++++++++++
        this.refresh();

        this.refreshGeneralLedger++;
        this.refreshGeneralLedger411++;

        if (this.accountableAccounts.length) {
            for (const aa of this.accountableAccounts) {
                await this.fetchTotals(aa.detailledBalanceInfos);
            }
        }
    }

    async validateFunction() {
        if (!this.validated) {
            this.validated = !this.validated;
            await this.generalLedger.setAllAccountableAccountsAsAudited();
            await this.createAdjustmentsData("VALIDATE");
        } else {
            this.validated = !this.validated;
            this.reviewed = 0;
            await this.generalLedger.setAllAccountableAccountsAsUnaudited();
            await this.createAdjustmentsData("UPDATE");
        }
    }

    // ****** TABLE : PERIOD'S DOCUMENTS - checkBox Array *******
    singleSelect: Boolean = true;

    // **************** TABLE : PERIOD'S DOCUMENTS *****************
    periodDocuments: Array<any> = [];
    selectedPeriod: string = "";
    periodsCustomer: any = {};
    provisionCustomer: any = {};
    unrecoverableLossCustomer: any = {};
    creditNotesCustomer: any = {};

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.items) {
            this.$apollo.queries.items.refetch();
        } else {
            debugger; // git-ignore
        }

        this.initialiseCompany();
    }

    upsertedACR() {
        this.refresh();
    }

    unlinkDocument(id) {
        this.connectedDocuments = this.connectedDocuments.filter((document) => document.id !== id);
    }

    showLinkedDocument(id) {
        this.documentToDisplay = { id };
        this.alreadyLinkedDoc = true;
        this.dialogAuditCheckDocumentsManager = true;
    }

    async openPeriodDocuments(data, title, customer) {
        if (this.selectedPeriod === title && this.periodsCustomer === customer) {
            this.expand = !this.expand;
        } else {
            this.selectedPeriod = title;
            this.periodsCustomer = customer;

            if (this.customers.length > 0) {
                if (data) {
                    this.periodDocuments = data.documents;
                }
            }
            this.expand = true;
            if (this.expand4 === true) {
                this.expand4 = !this.expand4;
            }
        }
    }

    // **************** TABLE : creditNotes *****************
    async openCreditNotesList(data, customer) {
        if (this.creditNotesCustomer === customer) {
            this.expand4 = !this.expand4;
        } else {
            this.creditNotesCustomer = customer;
            if (this.customers.length > 0) {
                if (data) {
                    this.existingCreditNotes = data;
                }
            }
            this.expand4 = true;
        }
    }

    // **************** ICON : DOCUMENT VIEW *****************
    openDocument(data) {
        if (data) {
            this.$router.push({
                name: "document",
                params: {
                    companyId: data.company.id,
                    id: data.id,
                },
            });
        }
    }

    // ************ V-WINDOW **************
    step: number = 1;

    async openCreditNoteDialog(invoice, periodsCustomer) {
        this.creditNoteDialog = true;

        this.selectedCustomer = periodsCustomer;
        this.currentDocACRid =
            (invoice.cctiAuditCheckResult && invoice.cctiAuditCheckResult.id) || "";

        this.dateCreditNote = this.formatDatePicker(this.accountingPeriod.end); // ** "YYYY-MM-DD"
        this.minDate = this.formatDatePicker(this.firstOpenPeriodStart);
        this.maxDate = this.formatDatePicker(this.lastOpenPeriodEnd);

        this.invoice = invoice;

        if (
            invoice.cctiAuditCheckResult &&
            invoice.cctiAuditCheckResult.results &&
            invoice.cctiAuditCheckResult.results[0]
        ) {
            this.resultDocumentIdsToDelete.push(invoice.cctiAuditCheckResult.results[0].id);

            if (
                invoice.cctiAuditCheckResult.results[0].accountingLines &&
                invoice.cctiAuditCheckResult.results[0].accountingLines.length
            ) {
                // ** if ACR.results
                // ** result is a creditNote, sign is opposite
                const aa7or6 = invoice.cctiAuditCheckResult.results[0].accountingLines.find(
                    (al) =>
                        al.accountableAccount.name.startsWith("7") ||
                        al.accountableAccount.name.startsWith("6"),
                );
                this.selected7and6AmountSigned.amount = aa7or6.amount || 0;
                this.selected7and6AmountSigned.positif =
                    (aa7or6 && aa7or6.amountSigned && aa7or6.amountSigned < 0) || false;

                const aa445 = invoice.cctiAuditCheckResult.results[0].accountingLines.find((al) =>
                    al.accountableAccount.name.startsWith("445"),
                );
                if (aa445) {
                    this.selected445AmountSigned.amount = aa445.amount || 0;
                    this.selected445AmountSigned.positif =
                        (aa445.amountSigned && aa445.amountSigned < 0) || false;
                }
            }
        } else {
            // ** if coming from invoice, sign is unchanged
            this.selected7and6AmountSigned.amount = Math.abs(invoice.doc7and6);
            this.selected7and6AmountSigned.positif =
                (invoice.doc7and6 && invoice.doc7and6.amount && invoice.doc7and6.amount > 0) ||
                false;

            this.selected445AmountSigned.amount = Math.abs(invoice.doc445);
            this.selected445AmountSigned.positif =
                (invoice.doc445 && invoice.doc445 && invoice.doc445.amount > 0) || false;
        }

        await this.calculateAdjustments();

        this.step++;
    }

    async calculateAdjustments() {
        const invoice = this.invoice;
        const periodsCustomer = this.periodsCustomer;

        const invoiceNumber = invoice.invoiceNumber;

        const data = [];
        const accountingLines = [];
        let document: any = {};

        let alWording: string = periodsCustomer.name + " - Avoir à établir ";
        if (Math.abs(invoice.doc7and6) === this.selected7and6AmountSigned.amount) {
            alWording +=
                " - partiel " +
                newCommonFormatCurrency(this.selected7and6AmountSigned.amount) +
                " HT - ";
        }
        alWording += invoiceNumber ? "s/" + invoiceNumber : "s/facture";
        alWording += " du " + this.formatDate(invoice.date) + " - ";
        alWording += newCommonFormatCurrency(Math.abs(invoice.doc7and6)) + " HT - ";
        alWording += invoice.vatAmount
            ? newCommonFormatCurrency(Math.abs(invoice.doc445)) + " TVA - "
            : "pas de TVA - ";
        alWording += newCommonFormatCurrency(Math.abs(invoice.doc411)) + " TTC - ";
        alWording += this.formatDate(this.dateCreditNote);

        // ** put VAT rate in 709 > 709020
        let vatRate = 0;
        if (invoice.doc445) {
            vatRate = mathFix((invoice.doc445 * 100) / invoice.doc7and6, 1);
        }

        let aa = "";

        switch (vatRate) {
            case 2.1:
                aa = `709002`;
                break;
            case 5.5:
                aa = `709005`;
                break;
            case 8.5:
                aa = `709008`;
                break;
            case 10:
                aa = `709010`;
                break;
            case 20:
                aa = `709020`;
                break;
            default:
                aa = `709000`;
                break;
        }

        const aLObject709 = {
            date: this.dateCreditNote,
            wording: alWording,
            amountSigned:
                this.selected7and6AmountSigned &&
                this.selected7and6AmountSigned.amount &&
                this.selected7and6AmountSigned.positif
                    ? -this.selected7and6AmountSigned.amount
                    : this.selected7and6AmountSigned.amount,
            amount: Math.abs(this.selected7and6AmountSigned.amount),
            accountableAccount: await getConnectAccountableAccount(this.$store, this.$apollo, aa),
            company: { connect: { id: this.companyId } },
            type: "ACCOUNTING",
        };
        accountingLines.push(aLObject709);

        if (invoice.doc445) {
            const aLObject44587 = {
                date: this.dateCreditNote,
                wording: alWording,
                amountSigned:
                    this.selected445AmountSigned.amount && this.selected445AmountSigned.positif
                        ? -this.selected445AmountSigned.amount
                        : this.selected445AmountSigned.amount,
                amount: Math.abs(this.selected445AmountSigned.amount),
                accountableAccount: await getConnectAccountableAccount(
                    this.$store,
                    this.$apollo,
                    "445870",
                    undefined,
                    undefined,
                    true,
                ),
                company: { connect: { id: this.companyId } },
                type: "ACCOUNTING",
            };
            accountingLines.push(aLObject44587);
        }

        const aLObject4198 = {
            date: this.dateCreditNote,
            wording: alWording,
            amountSigned:
                this.selected7and6AmountSigned &&
                this.selected7and6AmountSigned.amount &&
                this.selected7and6AmountSigned.positif &&
                this.selected445AmountSigned.amount &&
                this.selected445AmountSigned.positif
                    ? this.selected7and6AmountSigned.amount + this.selected445AmountSigned.amount
                    : -(
                          this.selected7and6AmountSigned.amount +
                          this.selected445AmountSigned.amount
                      ),
            amount: Math.abs(
                this.selected7and6AmountSigned.amount + this.selected445AmountSigned.amount,
            ),
            accountableAccount: await getConnectAccountableAccount(
                this.$store,
                this.$apollo,
                "419800",
                undefined,
                undefined,
                true,
            ),
            thirdPartyCompany: { connect: { id: invoice.thirdPartyCompany.id } },
            company: { connect: { id: this.companyId } },
            type: "ACCOUNTING",
        };
        accountingLines.push(aLObject4198);

        document = getEmptyDocument(
            this.companyId,
            alWording,
            "MISCELLANEOUS_OPERATION",
            this.dateCreditNote,
            this.currentUser.id,
            invoice.thirdPartyCompany.id,
            accountingLines,
            true,
        );
        document.data = {
            // creditNotesToIssues: {
            // accountingLines: accountingLines,
            closureCreditNoteOf: {
                id: invoice.id,
                invoiceNumber: invoice.invoiceNumber,
                date: invoice.date,
                thirdPartyCompany: { connect: { id: invoice.thirdPartyCompany.id } },
                accountableAccountName: invoice.accountingLines.find((ial) =>
                    ial.accountableAccount.name.startsWith("7"),
                ).accountableAccount.name,
            },
        };
        this.creditNote = document;
    }

    quitCreditNoteDialog() {
        this.creditNoteDialog = false;
        this.step = 1;
        this.selectedCustomer = {};
        this.invoice = {};
        this.selected7and6AmountSigned = {
            amount: 0,
            positif: true,
        };
        this.selected445AmountSigned = {
            amount: 0,
            positif: true,
        };
        // this.currentDocumentData = []
        this.dateCreditNote = moment().format("YYYY-MM-DD");
        // this.creditNotes = []
        this.minDate = this.firstOpenPeriodStart;
        this.maxDate = this.lastOpenPeriodEnd;
    }

    async previous(stepNumber) {
        this.step -= stepNumber;
    }

    async next(stepNumber) {
        this.step += stepNumber;
    }

    async onDatePickerChange4(date) {
        this.dateCreditNote = moment(date).format("YYYY-MM-DD");
    }

    // ***************** DELETE ACR **********************
    async deleteAuditCheckResult(acrId) {
        await this.$apollo.mutate({
            mutation: DELETE_AUDIT_CHECK_RESULT_AND_RESULTS,
            variables: { id: acrId } || {},
        });

        this.refresh();
    }

    async validateCreditNote() {
        const upsertVariables: any = {
            id:
                (this.invoice &&
                    this.invoice.cctiAuditCheckResult &&
                    this.invoice.cctiAuditCheckResult.id) ||
                "",
            auditCheckKey: this.acKey,
            key: this.acKey + "_" + this.companyId + "_" + this.invoice.id,
            companyId: this.companyId,
            status: "UNKNOWN",
            accountingPeriodCreate: undefined,
            accountingPeriodUpdate: undefined,
            documentCreateConnection: { connect: { id: this.invoice.id } },
            documentUpdateConnection: { connect: { id: this.invoice.id } },
            thirdPartyCompanyCreate: { connect: { id: this.selectedCustomer.id } } || undefined,
            thirdPartyCompanyUpdate: { connect: { id: this.selectedCustomer.id } } || undefined,
            // documentCreateConnection: creditNote.data.closureCreditNoteOf.id,
            // // no need for bankTransaction: only in "encaissements"
            // // no AAE closure credit note
            // bankTransactionCreateConnection: creditNote.data.closureCreditNoteOf.id,
            documents: [this.creditNote],
            deleteDocuments: this.resultDocumentIdsToDelete,
            data: [],
            // data: JSON.parse(JSON.stringify(this.currentDocumentData))
        };

        // eslint-disable-next-line no-await-in-loop
        const resultUpdatedInvoices: any = await this.$apollo.mutate({
            mutation: UPSERT_AUDIT_CHECK_RESULT__CONNECT_EXISTING_DOCUMENT,
            variables: upsertVariables,
        });

        this.refresh();
    }

    onQueryDone411NL(data) {
        if (data.generalLedger?.length) {
            this.totalBalance411NL = -data.total411Balance;
            this.show411NL = true;
        } else {
            this.show411NL = false;
        }
    }

    onQueryDone411NLNextPeriod(data) {
        if (data.generalLedger?.length) {
            this.totalBalance411NLNextPeriod = -data.total411Balance;
            this.show411NLNextPeriod = true;
        } else {
            this.show411NLNextPeriod = false;
        }
    }

    onQueryDone4198NL(data) {
        if (data.generalLedger?.length) {
            this.totalBalance4198NL = mathFix(data.totalBalance, 2);
            this.show4198NL = true;
        } else {
            this.show4198NL = false;
        }
    }

    onQueryDone4198NLNextPeriod(data) {
        if (data.generalLedger?.length) {
            this.totalBalance4198NLNextPeriod = mathFix(data.totalBalance, 2);
            this.show4198NLNextPeriod = true;
        } else {
            this.show4198NLNextPeriod = false;
        }
    }

    aaExpand(accountableAccount) {
        accountableAccount.expand = !accountableAccount.expand;
    }

    get disabledValidateBtn() {
        if (!this.invoice || !this.invoice.doc7and6) {
            return true;
        }

        if (this.accountingPeriod && this.accountingPeriod.closed) {
            return true;
        }

        if (this.invoice && this.invoice.doc7and6 && this.selected7and6AmountSigned.amount) {
            const amountSigned7and6 = this.selected7and6AmountSigned.positif
                ? this.selected7and6AmountSigned.amount
                : -this.selected7and6AmountSigned.amount;

            if (
                amountSigned7and6 &&
                ((amountSigned7and6 > 0 && this.invoice.doc7and6 >= amountSigned7and6) ||
                    (amountSigned7and6 < 0 && this.invoice.doc7and6 <= amountSigned7and6))
            ) {
                if (this.invoice.doc445) {
                    if (this.selected445AmountSigned.amount) {
                        const amountSigned445 = this.selected445AmountSigned.positif
                            ? this.selected445AmountSigned.amount
                            : -this.selected445AmountSigned.amount;

                        if (
                            amountSigned445 &&
                            amountSigned445 > 0 &&
                            this.invoice.doc445 >= amountSigned445
                        ) {
                            return false;
                        } else if (
                            amountSigned445 &&
                            amountSigned445 < 0 &&
                            this.invoice.doc445 <= amountSigned445
                        ) {
                            return false;
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                } else {
                    return false;
                }
            }
        }

        return true;
    }

    actionColor(invoice) {
        if (
            !invoice.cctiAuditCheckResult ||
            !invoice.cctiAuditCheckResult.results ||
            !invoice.cctiAuditCheckResult.results.length
        ) {
            return "primary";
        } else if (
            invoice.cctiAuditCheckResult &&
            invoice.cctiAuditCheckResult.status &&
            invoice.cctiAuditCheckResult.status === "TO_UPDATE"
        ) {
            return "red";
        }
        return "primary";
    }

    get closedPeriod() {
        if (this.accountingPeriod) {
            return closedPeriod(this.accountingPeriod);
        }
    }

    initialiseCompany() {
        // this.accountingPeriod = null
        this.company = null;
        this.firstOpenPeriodStart = "";
        this.lastOpenPeriodEnd = "";

        this.shortComment = "";
        this.comment = "";

        // ** generalLedger
        this.totalBalance411NL = 0;
        this.totalBalance411NLNextPeriod = 0;
        this.totalBalance4198NL = 0;
        this.totalBalance4198NLNextPeriod = 0;

        this.invoice = {};
        this.auditCheckResult = {};
        this.currentDocACRid = "";
        // this.previousDocumentsIds = []
        this.resultDocumentIdsToDelete = [];
        this.creditNoteDialog = false;
        this.selectedCustomer = {};
        this.minDate = "";
        this.maxDate = "";
        this.dateCreditNote = moment().format("YYYY-MM-DD");
        this.creditNote = {};
        this.existingCreditNotes = [];
        this.globalCreditNoteNetAmount = 0.0;
        this.globalCreditNoteVatAmount = 0.0;
        this.globalCreditNoteVatRate = 0.0;
        this.calculatedVatRate = 0.0;
        this.globalCreditNoteGrossAmount = 0.0;
        this.invoiceNumber = "";
        this.singleSelect = true;
        this.periodDocuments = [];
        this.selectedPeriod = "";
        this.periodsCustomer = {};
        this.provisionCustomer = {};
        this.unrecoverableLossCustomer = {};
        this.creditNotesCustomer = {};
        this.step = 1;
    }
}

export default toNative(CheckCreditNotesToIssue);
</script>
